import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ProjectTemplatePopup = loadAsyncComponent(
  () => import(/* webpackChunkName: "ProjectTemplatePopup" */ './Container'),
  'popup'
);
